import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { NAV_LINKS } from '../data/mock';
import { Button } from './ui/button';

const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md shadow-sm py-2'
          : 'bg-white/70 backdrop-blur-sm py-3'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <button
          onClick={() => scrollTo('#home')}
          className="flex items-center group"
          aria-label="Hello Foundation home"
        >
          <img
            src="/assets/logo.jpg"
            alt="Hello Foundation — Baytul Hafiza"
            className={`transition-all duration-300 group-hover:scale-105 ${
              scrolled ? 'h-12' : 'h-14'
            } w-auto`}
          />
        </button>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV_LINKS.map((l) => (
            <button
              key={l.label}
              onClick={() => scrollTo(l.href)}
              className="text-sm font-medium text-[#0B3B44] hover:text-[#F55B26] transition-colors relative group"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#F55B26] group-hover:w-full transition-all duration-300" />
            </button>
          ))}
        </nav>

        <div className="hidden lg:block">
          <Button
            onClick={() => scrollTo('#donate')}
            className="bg-[#F55B26] hover:bg-[#E14D1F] text-white font-semibold px-6 rounded-full shadow-md hover:shadow-lg transition-all"
          >
            Donate Now
          </Button>
        </div>

        <button
          onClick={() => setOpen(!open)}
          className="lg:hidden p-2 text-[#0B3B44]"
          aria-label="Menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-slate-100 shadow-lg">
          <div className="px-6 py-4 flex flex-col gap-3">
            {NAV_LINKS.map((l) => (
              <button
                key={l.label}
                onClick={() => scrollTo(l.href)}
                className="text-left py-2 text-[#0B3B44] font-medium hover:text-[#F55B26]"
              >
                {l.label}
              </button>
            ))}
            <Button
              onClick={() => scrollTo('#donate')}
              className="bg-[#F55B26] hover:bg-[#E14D1F] text-white font-semibold mt-2 rounded-full"
            >
              Donate Now
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
